import { Pipe, PipeTransform } from '@angular/core';

import { regiaoSituacoes } from '../regiao-situacao';

@Pipe({
    name: 'regiaoSituacao'
})
export class RegiaoSituacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = regiaoSituacoes.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return regiaoSituacoes[index].nome;
        }
        return '';
    }
}
